<template>
  <b-container fluid id="edit-school">
    <div id="edit-school">
      <h1 class="title">Edit {{ schoolName }}</h1>
      <div id="alerts">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >You have successfully edited this school!</b-alert>
        <b-alert :show="showError" dismissible variant="danger">
          Something went wrong. Please check all required fields and try
          again.
        </b-alert>
      </div>
      <b-row class="mt-4">
        <b-col>
          <school-basic></school-basic>
        </b-col>
        <b-col>
          <pupils-languages></pupils-languages>
        </b-col>
        <b-col>
          <geo-info singular="school" plural="schools" :coords="true" parent="school"></geo-info>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="School Teachers" active>
                <div class="teachers">
                  <h4 class="sub-title">School Teachers</h4>
                  <school-teachers></school-teachers>
                </div>
              </b-tab>
              <b-tab title="School Finance">
                <div class="finance">
                  <h4 class="sub-title">School Finance</h4>
                  <school-financing></school-financing>
                </div>
              </b-tab>
              <b-tab title="School Population">
                <div class="population">
                  <h4 class="sub-title">School Population</h4>
                  <school-population></school-population>
                </div>
              </b-tab>
              <b-tab title="School Structure">
                <div class="structure">
                  <h4 class="sub-title">School Structure</h4>
                  <school-structure></school-structure>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
      <br />
      <confirm-submit v-if="isAdmin || isSRC"></confirm-submit>
      <b-button
        v-if="isAdmin || isSRC"
        :size="'lg'"
        :variant="'primary'"
        class="app_school_btn mb-4"
        @click.prevent="updateSchool"
        :disabled="isDisabled"
      >Edit School</b-button>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmSubmit from "@/components/ConfirmSubmit";
import SchoolFinancing from "@/components/SchoolFinancing";
import SchoolStructure from "@/components/SchoolStructure";
import SchoolBasic from "@/components/SchoolBasic";
import SchoolPopulation from "@/components/SchoolPopulation";
import PupilsLanguages from "@/components/PupilsLanguages";
import SchoolTeachers from "@/components/SchoolTeachers";
import GeoInfo from "@/components/GeoInfo";
import Breadcrumb from "@/components/Breadcrumb";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "EditSchool",
  mixins: [flash, scrollTo],
  components: {
    SchoolFinancing,
    SchoolStructure,
    SchoolBasic,
    PupilsLanguages,
    GeoInfo,
    SchoolTeachers,
    SchoolPopulation,
    ConfirmSubmit,
    Breadcrumb
  },
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOL: "schools/GET_SCHOOL",
      UPDATE_SCHOOL: "schools/UPDATE_SCHOOL",
      RESET_SCHOOLS_STATE: "schools/RESET_SCHOOLS_STATE"
    }),
    async updateSchool() {
      if (!this.$store.state.confirmed) {
        alert("Please confirm the information above is correct");
        return;
      }
      if (
        this.$store.state.schools.school.name === "" ||
        this.$store.state.schools.school.country === ""
      ) {
        this.scrollTo(0, 0);
        this.flashError();
      } else {
        this.isDisabled = true;
        await this.UPDATE_SCHOOL();
        this.scrollTo(0, 0);
        this.flashSuccess();
        await this.$store.commit("resetConfirmed");
        await this.RESET_SCHOOLS_STATE();
        setTimeout(() => this.$router.push({ name: "SchoolsList" }), 1500);
      }
    }
  },
  computed: {
    ...mapGetters({
      schoolName: "schools/getSchoolName",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    })
  },
  created() {
    this.GET_SCHOOL();
  }
};
</script>

<style scoped>
#edit-school {
  width: 90%;
  white-space: nowrap;
  margin: 0 auto;
  text-align: center;
}
form input,
.form div {
  margin: 20px;
}
.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
</style>
